var _g, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMarried(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "User,Profile.14",
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 661",
    fill: "none",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2341",
    d: "M18.634 12.095a5.729 5.729 0 11-8.1 0 5.729 5.729 0 018.1 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2342",
    d: "M39.468 12.095a5.729 5.729 0 11-8.1 0 5.729 5.729 0 018.1 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2343",
    d: "M45.834 39.584a10.417 10.417 0 10-20.833 0 10.417 10.417 0 00-20.834 0"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2344",
    d: "M0 0h50v50H0z",
    fill: "none"
  })));
}

export default SvgMarried;


//////////////////
// WEBPACK FOOTER
// ./src/icons/Married.svg
// module id = 850
// module chunks = 101